import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'

const LoanStatementPageUI = ({ context, errorList, loanStatementList, response, onRefreshClick }) =>
    <SuperUserHomePageUI context={context} className='pg_su_ln_stmt ' topnav='accounts' dimension='w1600'
        headerText='Loan Statement' centered={!loanStatementList || !errorList}
        page='loanStatement'
    >
        {
            (!loanStatementList || !errorList) &&
            <SpinnerComponentUI />
        }
        {
            loanStatementList &&
            <>
                <LRTableActionsUI location='top'
                    left={
                        <span className='g_flex_left g_flex_h'>
                            <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
                            <span className='g_m_left_100 g_large'><b>Loan Statement</b></span>
                        </span>
                    }
                    right={
                        <span />
                    }
                />
            </>
        }
        {
            loanStatementList && loanStatementList.length !== 0 &&
            <LoanStatementUI
                loanStatementList={loanStatementList}
                response={response}
            />
        }
        {
            loanStatementList && loanStatementList.length === 0 &&
            <EmptyListUI 
            context={context}
            createEnabled={false}
            createDisabledMessageLabel='No loan statement found'
            />
        }
    </SuperUserHomePageUI>

const LoanStatementUI = ({ loanStatementList, response }) =>
    <div>
        <CardUI className='g_m_top_100'>
            <table>
                <thead className='g-sticky'>
                    <tr className='head'>
                        <td></td>
                        <th className='g_p_left_100'>Date</th>
                        <th className='g_p_left_100'>Description</th>
                        <th className='g_p_left_100'>Debit</th>
                        <th className='g_p_left_100'>Credit</th>
                        <th className='g_p_left_100'>Dsra Current</th>
                        <th className='g_p_left_100'>Excess Amount</th>
                        <th className='g_p_left_100'>Dsra Amount</th>
                        <th className='g_p_left_100'>Loan Balance</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        loanStatementList && loanStatementList.map((loanStatement, index) =>
                            <tr className='acc' key={index}>
                                <td className='left'>{index + 1}.</td>
                                <td className='left g_no_wrap_2'>{loanStatement.dateF1}</td>
                                <td className='left g_no_wrap_2'>{loanStatement.description}</td>
                                <td className='g_text_right amt'>{loanStatement.amount < 0 ? loanStatement.amountF5 : ''}</td>
                                <td className='g_text_right amt'>{loanStatement.amount > 0 ? loanStatement.amountF5 : ''}</td>
                                <td className='g_text_right amt'>{loanStatement.dsraCurrentF5}</td>
                                <td className='g_text_right amt'>{loanStatement.excessAmountF5}</td>
                                <td className='g_text_right amt'>{loanStatement.dsraAmountF5}</td>
                                <td className='g_text_right amt'>{loanStatement.loanBalanceF5}</td>
                            </tr>
                        )
                    }
                </tbody>
            </table>
        </CardUI>
    </div>

export default LoanStatementPageUI